var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5601 1.0857C16.9048 0.434324 15.8466 0.434324 15.1913 1.0857L9.16011 7.0329L3.21291 1.0857C2.55765 0.434324 1.49937 0.434324 0.844109 1.0857C0.526064 1.40115 0.347168 1.83055 0.347168 2.2785C0.347168 2.72645 0.526064 3.15585 0.844109 3.4713L7.96731 10.5945C8.28276 10.9125 8.71216 11.0914 9.16011 11.0914C9.60806 11.0914 10.0375 10.9125 10.3529 10.5945L17.5601 3.4713C17.8782 3.15585 18.0571 2.72645 18.0571 2.2785C18.0571 1.83055 17.8782 1.40115 17.5601 1.0857Z",
    fill: "#060316",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropDown);
export default __webpack_public_path__ + "static/media/drop-down.3afce1bf7a27322ef31fb582eb13fe8e.svg";
export { ForwardRef as ReactComponent };